import styled from "styled-components";

export const ContainerStatus = styled.div`
    margin-bottom: 20px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
    display: flex;
    justify-content: flex-end;
    gap: 24px;
    flex-wrap: wrap;
    align-items: center;
`;

export const FilterCheckbox = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    padding: 8px 12px;
    border-radius: 6px;
    transition: background 0.2s;

    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
    }

    :hover {
        background: #e9ecef;
    }
`;

export const FilterLegend = styled.span<{ color?: string }>`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;

    color: ${props => props.color};
`;